import moment from '@narvar/moment-shim';
import { parseDate } from '../services/order-info/utils';
import { localeMapping } from './localizedCountries';
import DATE_FORMATS from './../constants/dateFormats';

export const timeWindowFormatter = (time, countryCode) => {
  const [from, to] = time.split('-');
  const format = (DATE_FORMATS[countryCode] || DATE_FORMATS.DEFAULT).time;
  const formattedFromTime = moment(from, 'HHmm').format(format);
  const formattedToTime = moment(to, 'HHmm').format(format);

  return `${formattedFromTime} - ${formattedToTime}`;
};

export const getDateTime = ({ locale, date, options: inputOptions }) => {
  const options = inputOptions || {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  };
  if (!date) return;
  let dateLocale;
  let output;
  let parsedDate;
  try {
    dateLocale = locale ? localeMapping({ locale, format: true }) : 'en-US';
  } catch (e) {
    dateLocale = 'en-US';
  }

  try {
    parsedDate = parseDate(date);
  } catch (e) {
    parsedDate = undefined;
  }
  if (parsedDate === undefined) {
    return undefined;
  }

  try {
    output = new Intl.DateTimeFormat(dateLocale, options).format(parsedDate);
  } catch (err) {
    try {
      const language = dateLocale.split('-')[0];
      const country = dateLocale.split('-')[1];
      output = new Intl.DateTimeFormat(language || country, options).format(parsedDate);
    } catch (e) {
      output = undefined;
    }
  }

  return output;
};

export const localeDateTime = ({ date, countryCode, formatType = 'fullDate' }) => {
  const formats = DATE_FORMATS[countryCode] || DATE_FORMATS.DEFAULT;
  const format =
    formats[formatType] || DATE_FORMATS.DEFAULT[formatType] || DATE_FORMATS.DEFAULT.fullDate;
  return moment(date).format(format);
};

export const isSameDate = (date1, date2) => {
  if (!date1 || !date2) return false;
  const d1 = moment(date1).startOf('day');
  const d2 = moment(date2).startOf('day');
  return d1.isSame(d2);
};
